import React from "react";
import cn from "classnames";

import { StyledButton } from "../shared-style";
import { IProps } from "./interfaces";

const Submit = ({ children, onClick, facebook, google, disabled, loading }: IProps) => (
    <StyledButton
        className={cn("button", facebook && "Facebook", google && "Google", loading && "button--loading")}
        onClick={onClick}
        disabled={disabled}
    >
        {children}
    </StyledButton>
);

export default Submit;
